import React, { useContext } from 'react';
import { ContextDevTool } from 'react-context-devtool';
import ReactBreakpoints from 'react-breakpoints';
import { MediaBreakpointsContext } from './MediaBreakpointsContext';

/**
 * @param {{ children: any; breakpoints: Record<string, number> }} props
 */
const MediaBreakpointsProvider = ({ children, breakpoints }) => {
  const context = useContext(MediaBreakpointsContext);

  // if it is created already, do not re-create it use the parent
  if (context?.breakpoints) {
    return children;
  }

  return (
    <MediaBreakpointsContext.Provider value={{ breakpoints }}>
      <ContextDevTool context={MediaBreakpointsContext} id="MediaBreakpointsContext" displayName="MediaBreakpointsContext" />
      <ReactBreakpoints breakpoints={breakpoints}>{children}</ReactBreakpoints>
    </MediaBreakpointsContext.Provider>
  );
};

export default MediaBreakpointsProvider;
